/**
 * Estimate the size of the main section based on the window width
 */
export function getMainSectionWidth() {
  return window.innerWidth - 400;
}
